function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 6.35 6.35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m0.99479 5.5401c-0.12096-0.041872-0.20216-0.1569-0.20103-0.28467 2.1e-4 -0.023755 0.0654-0.32348 0.14488-0.666l0.1445-0.62276 1.1652-1.1682c0.64084-0.64254 1.1694-1.1682 1.1746-1.1681 0.00525 6.76e-5 0.30146 0.29284 0.65837 0.65063l0.64892 0.65052-0.47897 0.47802c-0.26343 0.26291-0.7917 0.79025-1.1739 1.1719l-0.69495 0.69383-0.07455 0.017065c-0.041025 0.0093967-0.31555 0.072995-0.61011 0.14124-0.57346 0.13294-0.61066 0.13858-0.70289 0.10664zm3.3348-3.5222-0.65124-0.65304 0.25941-0.25923c0.22241-0.22225 0.26748-0.26292 0.31605-0.28515 0.0705-0.03225 0.15458-0.035483 0.23132-0.008946 0.048525 0.016764 0.08367 0.049615 0.54012 0.5052 0.54953 0.54847 0.53138 0.52593 0.53087 0.65885-4.725e-4 0.12512-6e-3 0.1325-0.30384 0.43262-0.14369 0.14464-0.26356 0.26292-0.26636 0.26286-3e-3 -6.78e-5 -0.29816-0.29396-0.65633-0.65313z",
    style: {
      fill: "#0066a4",
      strokeWidth: 0.0094527
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.9535c23a.svg";
export { ForwardRef as ReactComponent };